// src/components/Dialogs/ConfirmDialog.js

import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

const ConfirmDialog = ({
  open,
  title = "Confirm",
  description = "",
  onClose,
  onConfirm,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  confirmButtonColor = "primary",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          margin: { xs: 2, sm: 3 },
          maxHeight: { xs: "calc(100% - 32px)", sm: "calc(100% - 64px)" },
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: { xs: "1.125rem", sm: "1.25rem" },
          pb: { xs: 1, sm: 2 },
        }}
      >
        {title || "Confirm Deletion"}
      </DialogTitle>
      <DialogContent
        sx={{
          px: { xs: 2, sm: 3 },
          py: { xs: 1, sm: 2 },
          fontSize: { xs: "0.875rem", sm: "1rem" },
        }}
      >
        {description || "Are you sure you want to delete this job? This action cannot be undone."}
      </DialogContent>
      <DialogActions
        sx={{
          px: { xs: 2, sm: 3 },
          py: { xs: 1.5, sm: 2 },
          gap: { xs: 1, sm: 1.5 },
          flexDirection: { xs: "column-reverse", sm: "row" },
        }}
      >
        <Button
          onClick={onClose}
          color="secondary"
          fullWidth={window.innerWidth < 600}
          sx={{
            height: { xs: "44px", sm: "40px" },
            color: "#757575",
            fontSize: { xs: "0.875rem", sm: "0.875rem" },
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          {cancelButtonText || "Cancel"}
        </Button>
        <Button
          onClick={onConfirm}
          color={confirmButtonColor}
          variant="contained"
          fullWidth={window.innerWidth < 600}
          sx={{
            height: { xs: "44px", sm: "40px" },
            backgroundColor: confirmButtonColor === "error" ? "#d32f2f" : "#1976d2",
            color: "#ffffff",
            fontSize: { xs: "0.875rem", sm: "0.875rem" },
            "&:hover": {
              backgroundColor: confirmButtonColor === "error" ? "#b71c1c" : "#1565c0",
            },
          }}
        >
          {confirmButtonText || "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  confirmButtonColor: PropTypes.string,
};

export default ConfirmDialog;
